import { DealerDriverDto } from "types/dealerDrivers";
import {
  CoverageAreaDriverItem,
  CoverageAreaProps,
} from "store/modules/Logistics/types.store";

import { DriverOption } from "./hooks/useMapAreaDriverSelection";

type CoverageAreaDriversFields = Pick<
  CoverageAreaProps,
  "drivers" | "hasDriver"
>;

export function buildMapAreaDriversStatePatch(params: {
  dealerId: string;
  driversToPersist: DriverOption[];
  drivers: DealerDriverDto[] | undefined;
}): Partial<CoverageAreaDriversFields> {
  const { dealerId, driversToPersist, drivers } = params;

  if (driversToPersist.length === 0) {
    return {
      drivers: [],
      hasDriver: false,
    };
  }

  const driversItems: CoverageAreaDriverItem[] = driversToPersist.map(
    (option, index) => {
      const matched = drivers?.find((driver) => driver.id === option.id);
      const name = matched?.name ?? option.label;
      return {
        id: option.id,
        priority: index,
        details: {
          id: option.id,
          dealerId,
          name,
          enabled: matched?.enabled ?? true,
        },
      };
    },
  );

  return {
    drivers: driversItems,
    hasDriver: true,
  };
}
